import { useParams } from 'react-router-dom';

import DevelopmentScreen from '../../features/development/layouts/development';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
//
//   /admin/development            → la sección, en Tareas
//   /admin/development/tiers      → los tiers, con `tiers:read`
//   /admin/development/tareas     → tablero o lista, según ?view=
//   /admin/development/revision   → la cola de entregas
//   /admin/development/hallazgos  → la pila esperando triage
//
// La pestaña vive en la ruta para que se enlace y el botón Atrás funcione. Las
// rutas viejas —/admin/tasks, /admin/reviews, /admin/findings— redirigen acá;
// lo que NO se movió son las pantallas de una tarea concreta (`/admin/tasks/:id`,
// `/new`, `/trace`), que no son listados y no pertenecen a una pestaña.

export default function DevelopmentPage() {
    const { tab } = useParams();
    return <DevelopmentScreen tab={tab} />;
}
